<template>
  <div class="container">
    <div class="page-header">
      <h3>Sign in</h3>
    </div>
    <div>
      <form id="form" @submit.prevent="signIn">
        <div v-bind:class="{'form-group': true, 'has-danger': errors.has('email')}">
          <input id="email" name="email" type="text" class="form-control" placeholder="Email address" v-model="email" v-validate="'required|email'">
          <span class="form-control-feedback" v-if="errors.has('email')">{{errors.first('email')}}</span>
        </div>
        <div v-bind:class="{'form-group': true, 'has-danger': errors.has('password')}">
          <input id="password" name="password" type="password" class="form-control" placeholder="Password" v-model="password" v-validate="'required|min:6'">
          <span class="form-control-feedback" v-if="errors.has('password')">{{errors.first('password')}}</span>
        </div>
        <input type="submit" class="btn btn-primary" value="Sign in">
      </form>
    </div>
    <p>You don't have an account ? You can
      <router-link to="/sign-up">create one</router-link>
    </p>
</div>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    signIn() {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          this.$router.replace('/plates');
        },
        (err) => {
          alert(`Oops. ${err.message}`);
        },
      );
    },
  },
};
</script>

<style scoped>
  /* "scoped" attribute limit the CSS to this component only */

  .login {
    margin-top: 40px;
  }

  input {
    margin: 10px 0;
    width: 20%;
    padding: 15px;
  }

  button {
    margin-top: 20px;
    width: 10%;
    cursor: pointer;
  }

  p {
    margin-top: 40px;
    font-size: 13px;
  }

  p a {
    text-decoration: underline;
    cursor: pointer;
  }

  .form-control-feedback {
    color: red;
    position: relative;
    display: inline;
  }
  input {
             display: block;
             margin : 0 auto;
        }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue